export default __webpack_public_path__ + "static/compensation-a5661487a308bd480b31fe6ef5ea0307.png";